import React from "react";
import { observer } from "mobx-react-lite";
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    whiteColor: {
        color: "white"
    },
    staticHelpBlock: {
        marginTop: theme.spacing(2),
        "& p": { marginBottom: theme.spacing(1.5) }
    },
    staticHelpLink: {
        color: theme.palette.primary.main
    }
}));

export default observer(function Help() {
    const classes = useStyles();
    const { t } = useTranslation("starfish");

    return (
        <div className={classes.whiteColor}>
            <Typography variant="h5">{t("profile.helpPage.title")}</Typography>
            <div className={classes.staticHelpBlock}>
                <Typography variant="body1">
                    {t("profile.helpPage.emailPrefix")}{" "}
                    <a href="mailto:support@starfishperks.com" className={classes.staticHelpLink}>
                        support@starfishperks.com
                    </a>
                </Typography>
                <Typography variant="body1">
                    {t("profile.helpPage.emailIncludeNotice")}
                </Typography>
                <Typography variant="body1">
                    {t("profile.helpPage.hours")}
                </Typography>
                <Typography variant="body1">
                    {t("profile.helpPage.responseTime")}
                </Typography>
                <Typography variant="body1" style={{ marginTop: 24 }}>
                    {t("profile.helpPage.thankYou")}
                </Typography>
                <Typography variant="body1">
                    {t("profile.helpPage.signOff")}
                </Typography>
            </div>
        </div>
    );
});
